/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Harsh Event Icon component.
 */
export const MapHarshEventIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='24' width='24' height='24' rx='12' transform='rotate(90 24 0)' fill='white' />
      <path fillRule='evenodd' clipRule='evenodd' d='M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47972 21.9938 2.00619 17.5203 2 12Z' fill='#E2231A' />
      <path fillRule='evenodd' clipRule='evenodd' d='M20 12L6 7L9.33333 12L6 17L20 12Z' fill='white' />
    </svg>
  );
};

export default MapHarshEventIcon;
